<img src="assets/images/no-results.svg" [alt]="'dtmUi.noResults.imageAltText' | transloco" />
<div class="title">{{ "dtmUi.noResults.message" | transloco }}</div>
<p *ngIf="areFiltersApplied$ | async">{{ "dtmUi.noResults.hintText" | transloco }}</p>
